define(['lodash'], function (_) {
    'use strict';

    const getMainSectionWidgetData = appData => _.find(_.get(appData, 'widgets'), widget => _.get(widget, 'appPage.name') && !_.get(widget, 'appPage.hidden'));

    return {
        getMainSectionWidgetData
    };
});
